import React from 'react';
import { pageHeroPhotos } from '../data/pageHeroPhotos';
import { ClockIcon, GlobeIcon, MailIcon, MapPinIcon, PhoneIcon, SmartphoneIcon } from 'lucide-react';
import { PageHeading } from '../components/PageHeading';
import { AppointmentRequest } from '../components/AppointmentRequest';
import { business, mapEmbedSrc, socials } from '../data/site';
import { usePageMeta } from '../hooks/usePageMeta';
const socialLabels: Record<string, string> = {
  Instagram: '@Eastendautorepair',
  Facebook: 'East End Automotive Repair LLC',
  TikTok: '@EastEndAutoRepair',
  SureCritic: 'Read our reviews'
};
export function Contact() {
  usePageMeta('Contact East End Automotive Repair | Oak Ridge, TN', 'Contact East End Automotive Repair at 274 Warehouse Rd, Oak Ridge, TN. Call (865) 206-2279, Monday through Friday, 8:00 AM to 5:00 PM.');
  return <>
      <PageHeading photo={{
      ...pageHeroPhotos.contact,
      position: 'center 52%',
      mobilePosition: '80% 50%'
    }} eyebrow="Contact" title="Contact East End Automotive Repair" intro="Calling the shop is the fastest way to get an answer about your vehicle. We answer the phone during business hours, Monday through Friday." data-id="element-512" data-mp="ab4jp95yg0w3" />

      <section className="w-full bg-white py-16 lg:py-24" data-id="element-513" data-mp="1e8ad51f4wp1p">
        <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-514" data-mp="1j7d4jj26ywr7">
          <div className="grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-515" data-mp="1j8xz38oiafp2">
            <div data-id="element-516" data-mp="mhw35ga8rwvb">
              <h2 className="font-display text-[28px] font-extrabold leading-[1.1] tracking-[-0.02em] text-ink sm:text-[34px]" data-id="element-517" data-mp="midxg7dcg10l">
                Shop details
              </h2>

              <dl className="mt-8 grid gap-7 sm:grid-cols-2" data-id="element-518" data-mp="vghil2kf2vrv">
                <div data-id="element-519" data-mp="10g2jhij5de78">
                  <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-steel/50" data-id="element-520" data-mp="10glxwp9l9kgi">
                    <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-521" data-mp="26vwe01wz9fkv" />
                    Shop phone
                  </dt>
                  <dd className="mt-2 text-[17px] font-bold text-ink" data-id="element-522" data-mp="2bxlo9fcdlp7w">
                    <a href={business.phoneHref} className="whitespace-nowrap hover:text-brand-dark" data-id="element-523" data-mp="1m5sgdm0j3sgz">
                      {business.phone}
                    </a>
                  </dd>
                </div>
                <div data-id="element-524" data-mp="1r66rxe1c9kjr">
                  <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-steel/50" data-id="element-525" data-mp="1r6zpboeeqxp8">
                    <SmartphoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-526" data-mp="13erlpa6fyj38" />
                    Text the shop
                  </dt>
                  <dd className="mt-2 text-[17px] font-bold text-ink" data-id="element-527" data-mp="1d6f98zzvnfzf">
                    <a href={business.smsHref} className="whitespace-nowrap hover:text-brand-dark" data-id="element-528" data-mp="1d8i6o53d0be6">
                      {business.phone}
                    </a>
                  </dd>
                </div>
                <div data-id="element-529" data-mp="fqrts6xe8mn2">
                  <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-steel/50" data-id="element-530" data-mp="fp6xabriqtmk">
                    <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-531" data-mp="2w53cho5apqfd" />
                    Email
                  </dt>
                  <dd className="mt-2 break-all text-[15px] text-steel/85" data-id="element-532" data-mp="2hh8i83bn3e06">
                    <a href={`mailto:${business.email}`} className="hover:text-brand-dark" data-id="element-533" data-mp="2mfaczlifh1rh">
                      {business.email}
                    </a>
                  </dd>
                </div>
                <div data-id="element-534" data-mp="3f3fwy61nqmq9">
                  <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-steel/50" data-id="element-535" data-mp="3f1v0gavs8tpr">
                    <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-536" data-mp="355i9hkrmgtyp" />
                    Website
                  </dt>
                  <dd className="mt-2 break-all text-[15px] text-steel/85" data-id="element-537" data-mp="1po812jnrq8c3">
                    <a href={business.websiteUrl} target="_blank" rel="noreferrer" className="hover:text-brand-dark" data-id="element-538" data-mp="1tre7bravrzik">
                      eeautomotiverepair.com
                    </a>
                  </dd>
                </div>
                <div data-id="element-539" data-mp="208r1kk063iye">
                  <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-steel/50" data-id="element-540" data-mp="2064t8i5gczf4">
                    <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-541" data-mp="2swmvxi29kys0" />
                    Address
                  </dt>
                  <dd className="mt-2 text-[15px] leading-relaxed text-steel/85" data-id="element-542" data-mp="2nximcqbfgz15">
                    {business.address.street}
                    <br data-id="element-543" data-mp="2ix4ilkgv0b8x" />
                    {business.address.city}, {business.address.state}{' '}
                    {business.address.zip}
                  </dd>
                </div>
                <div data-id="element-544" data-mp="17kbpo6cc1gra">
                  <dt className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-steel/50" data-id="element-545" data-mp="17hfs4j4ecu3d">
                    <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-546" data-mp="3f5ajqxt7e53b" />
                    Hours
                  </dt>
                  <dd className="mt-2 space-y-1 text-[15px] text-steel/85" data-id="element-547" data-mp="3j6dy1fvlrt2f">
                    {business.hours.map(h => <p key={h.days} data-id="element-548" data-mp="3o5710ed9k1oc">
                        <span className="text-steel/55" data-id="element-549" data-mp="3o45n824v512x">{h.days}:</span>{' '}
                        {h.time}
                      </p>)}
                  </dd>
                </div>
              </dl>

              <a href={business.phoneHref} className="mt-10 inline-flex items-center gap-3 whitespace-nowrap rounded-md bg-brand px-7 py-4 font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light" data-id="element-550" data-mp="6p8o0kfa1c7w">
                <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-551" data-mp="2cigtucv9jvh7" />
                Call {business.phone}
              </a>

              <h3 className="mt-12 text-[12px] font-bold uppercase tracking-[0.14em] text-steel/50" data-id="element-552" data-mp="2hil95zkfqk5u">
                Follow the shop
              </h3>
              <ul className="mt-4 flex flex-wrap gap-2.5" data-id="element-553" data-mp="3kuafn8fxohrc">
                {socials.map(s => <li key={s.label} data-id="element-554" data-mp="3fvpgzdgby650">
                    <a href={s.href} target="_blank" rel="noreferrer" className="inline-flex flex-col rounded-md border border-black/15 px-4 py-2.5 transition-colors duration-150 ease-out hover:border-ink" data-id="element-555" data-mp="3ttdziemxd16w">
                      <span className="text-[13px] font-bold text-ink" data-id="element-556" data-mp="2m1ko69ikzu5">
                        {s.label}
                      </span>
                      <span className="text-[12px] text-steel/60" data-id="element-557" data-mp="gg29a76r56gs">
                        {socialLabels[s.label] ?? ''}
                      </span>
                    </a>
                  </li>)}
              </ul>
            </div>

            <div data-id="element-558" data-mp="ledj4hx1rgz0">
              <div className="overflow-hidden rounded-xl border border-black/10" data-id="element-559" data-mp="levoc41ot5j2">
                <iframe title={`Map to ${business.name}`} src={mapEmbedSrc} loading="lazy" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen className="block h-[300px] w-full border-0 sm:h-[340px] lg:h-[440px]" data-id="element-560" data-mp="1505ou7j0m6ey" />
              </div>
              <p className="mt-3 text-[13.5px] leading-relaxed text-steel/65" data-id="element-561" data-mp="m8wc7pdy71j5">
                We are located at {business.address.street} in{' '}
                {business.address.city}, {business.address.state}. Parking is
                out front of the service bays.
              </p>
            </div>
          </div>
        </div>
      </section>

      <AppointmentRequest data-id="element-562" data-mp="ha1n65pe0gql" />
    </>;
}